import { takeLatest, call, put, all } from 'redux-saga/effects';
import { toast } from 'react-toastify';
import moment from 'moment';

import api from '~/services/api';
import { CatchErrors } from '../common';

import {
  taskPlanningIndexRequest, taskPlanningIndexSuccess, taskPlanningIndexFailure, taskPlanningCreateSuccess,
  taskPlanningCreateFailure, taskPlanningReadSuccess, taskPlanningReadFailure, taskPlanningUpdateSuccess,
  taskPlanningUpdateFailure, taskPlanningDeleteSuccess, taskPlanningDeleteFailure
} from './actions';
import { taskHistoryIndexRequest } from '../taskHistory/actions';

export function* onIndex({ payload }) {
  try {
    const { id, projectId } = payload;

    const response = yield call(api.get, `projects/${projectId}/tasks/${id}/planning`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskPlanningIndexSuccess(data));
  }
  catch (err) {
    yield put(taskPlanningIndexFailure());
  }
}

export function* onCreate({ payload }) {
  try {
    const { projectId, taskId, startAt, endAt } = payload.data;

    const formData = new FormData();

    formData.append('startAt', moment(startAt).format("YYYY-MM-DD HH:mm"));
    formData.append('endAt', moment(endAt).format("YYYY-MM-DD HH:mm"));
    formData.append('manual', 1);

    const response = yield call(api.post, `projects/${projectId}/tasks/${taskId}/planning`, formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskPlanningCreateSuccess(data));
    yield put(taskPlanningIndexRequest(taskId, projectId));
    yield put(taskHistoryIndexRequest(projectId, taskId, [{ page: 1 }, { pageSize: 10 }]));

    toast.success('Tempo adicionado com sucesso');
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskPlanningCreateFailure());
  }
}

export function* onRead({ payload }) {
  try {
    const { id, projectId, taskId } = payload;

    const response = yield call(api.get, `projects/${projectId}/tasks/${taskId}/planning/${id}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskPlanningReadSuccess(data));
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskPlanningReadFailure());
  }
}

export function* onUpdate({ payload }) {
  try {
    const { id, projectId, taskId, startAt, endAt } = payload.data;

    const formData = new FormData();

    if (startAt) formData.append('startAt', moment(startAt).format("YYYY-MM-DD HH:mm"));
    if (endAt) formData.append('endAt', moment(endAt).format("YYYY-MM-DD HH:mm"));
    formData.append('manual', 1);

    const response = yield call(api.post, `projects/${projectId}/tasks/${taskId}/planning/${id}`, formData);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;
    if (!result.data) throw 'Verifique sua conexão';

    const data = result.data;

    yield put(taskPlanningUpdateSuccess(data));
    yield put(taskPlanningIndexRequest(taskId, projectId));
    yield put(taskHistoryIndexRequest(projectId, taskId, [{ page: 1 }, { pageSize: 10 }]));

    toast.success('Tempo atualizado com sucesso');
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskPlanningUpdateFailure());
  }
}

export function* onDelete({ payload }) {
  try {
    const { id, taskId, projectId } = payload;

    const response = yield call(api.delete, `projects/${projectId}/tasks/${taskId}/planning/${id}`);

    if (!response) throw 'Verifique sua conexão';

    const result = response.data;

    if (!result) throw 'Verifique sua conexão';
    if (!result.success) throw result.error;

    const data = result.data;

    yield put(taskPlanningDeleteSuccess());
    yield put(taskPlanningIndexRequest(taskId, projectId));
    yield put(taskHistoryIndexRequest(projectId, taskId, [{ page: 1 }, { pageSize: 10 }]));

    toast.success(result.message);
  }
  catch (err) {
    CatchErrors(err);
    yield put(taskPlanningDeleteFailure());
  }
}

export default all([
  takeLatest('@taskPlannings/INDEX_REQUEST', onIndex),
  takeLatest('@taskPlannings/CREATE_REQUEST', onCreate),
  takeLatest('@taskPlannings/READ_REQUEST', onRead),
  takeLatest('@taskPlannings/UPDATE_REQUEST', onUpdate),
  takeLatest('@taskPlannings/DELETE_REQUEST', onDelete),
]);
